<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<breadcrumbs
			:breadcrumbs="page.breadcrumbs"
			:class="page.headingImage ? '' : 'no-slider'"
			:home="defaults[locale].website.hotelName"
		/>

		<section id="intro" class="main-content intro">
			<div class="row">
				<div class="columns column6">
					<h4 v-if="page.subtitle" class="subtitle">
						<span>{{ page.subtitle }}</span>
						<div class="subtitle-line" />
					</h4>
					<h1>{{ page.title }}</h1>
					<div class="animated-logo" />
				</div>

				<div class="columns column6">
					<div v-parse-links v-html="page.content" />
				</div>
			</div>
		</section>

		<section class="main-content background-color align-center">
			<div class="row promotions-row flex-row slide-row">
				<div
					v-for="item in defaults[locale].broodjeVelootje.block"
					:key="item.filename"
					class="block flex-item"
				>
					<div class="block-img">
						<nuxt-link :to="item.link" target="_blank">
							<picture>
								<source
									v-if="item.imageOverviewWebp"
									:srcset="item.imageOverviewWebp"
									type="image/webp"
								/>
								<source :srcset="item.imageOverview" />
								<img loading="lazy" :src="item.imageOverview" :alt="item.imageOverviewAlt" />
							</picture>
						</nuxt-link>
					</div>
					<div class="block-content">
						<h3>
							<nuxt-link :to="item.link" target="_blank">
								{{ item.title }}
							</nuxt-link>
						</h3>
						<div v-parse-links v-html="item.content" />
						<nuxt-link v-if="item.link" :to="item.link" target="_blank" class="button button-no-fill">
							{{ item.button }}
						</nuxt-link>
					</div>
				</div>
			</div>
		</section>

		<contentblocks v-if="page.contentblocks && page.contentblocks.length" :items="page.contentblocks" />

		<review-slider v-if="page.showReviewSlider" :header="defaults[locale].website.reviewsHeader" />
		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
		<pre-footer v-if="page.footerSection?.length" :footer-section="page.footerSection[0]" />
		<newsletter
			v-if="page.showNewsletter"
			:header="defaults[locale].website.newsletterHeader"
			:content="defaults[locale].website.newsletterContent"
			:button="defaults[locale].website.newsletterButton"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();
</script>

<style lang="scss" scoped>
.animated-logo {
	background: url('~/assets/images/animated-gif-broodje-velootje.gif') no-repeat center center;
	background-size: 100%;
	width: 500px;
	height: 250px;
	max-width: 100%;
}
</style>
